import {getField, updateField} from "vuex-map-fields"

export const state = () => ({
    promo : {},
    promo_modified : null,
    promo_loading : false
})

export const getters = {
    getField,
}

export const mutations = {
    updateField,
}
